import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0506 = React.lazy(() => import('./symbols/0506_suitcase_travel_baggage_luggage'));
const Symbol0507 = React.lazy(() => import('./symbols/0507_suitcase_travel_baggage_luggage'));
const Symbol0508 = React.lazy(() => import('./symbols/0508_tag_flight_baggage_luggage'));
const Symbol0509 = React.lazy(() => import('./symbols/0509_globus_world_travel_regional'));
const Symbol0510 = React.lazy(() => import('./symbols/0510_passport_travel'));
const Symbol0511 = React.lazy(() => import('./symbols/0511_suitcase_tag_travel_baggage_luggage'));
const Symbol0512 = React.lazy(() => import('./symbols/0512_flight_airport_transport_travel'));
const Symbol0513 = React.lazy(() => import('./symbols/0513_car_travel_road_trip'));
const Symbol0514 = React.lazy(() => import('./symbols/0514_camping_caravan_car_motorhome_travel'));
const Symbol0515 = React.lazy(
  () => import('./symbols/0515_4x4_offroad_jeep_mountains_tour_safari')
);
const Symbol0516 = React.lazy(
  () => import('./symbols/0516_paris_city_travel_honeymoon_love_romantic')
);
const Symbol0517 = React.lazy(
  () => import('./symbols/0517_san_francisco_california_bridge_golden_gate')
);
const Symbol0518 = React.lazy(() => import('./symbols/0518_rome_italy_colosseum'));
const Symbol0519 = React.lazy(() => import('./symbols/0519_rio_de_jeneiro_brasil_jesus'));
const Symbol0520 = React.lazy(() => import('./symbols/0520_pisa_italy_leaning_tower'));
const Symbol0521 = React.lazy(() => import('./symbols/0521_petronal_tower_malaysia'));
const Symbol0522 = React.lazy(() => import('./symbols/0522_dubai_hotel_burj_al_arab'));
const Symbol0523 = React.lazy(() => import('./symbols/0523_berlin_brandenburger_tor_germany'));
const Symbol0524 = React.lazy(() => import('./symbols/0524_syndey_opera_australia'));
const Symbol0525 = React.lazy(() => import('./symbols/0525_ancient_egypt_pyramid'));
const Symbol0526 = React.lazy(() => import('./symbols/0526_netherlands_wind_mill'));
const Symbol0527 = React.lazy(() => import('./symbols/0527_lighthouse_shore_coast_sea'));
const Symbol0528 = React.lazy(() => import('./symbols/0528_castle'));
const Symbol0529 = React.lazy(() => import('./symbols/0529_cementary'));
const Symbol0530 = React.lazy(() => import('./symbols/0530_favorite_place_map'));
const Symbol0531 = React.lazy(() => import('./symbols/0531_baggage_luggage_hotel'));
const Symbol0532 = React.lazy(() => import('./symbols/0532_park_tree'));
const Symbol0533 = React.lazy(() => import('./symbols/0533_baloon_hot_air'));
const Symbol0534 = React.lazy(() => import('./symbols/0534_vespa_scooter_motorbike'));

export interface IProps {}

const Travel: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0506_suitcase_travel_baggage_luggage" symbol={<Symbol0506 />} />
      <LazySymbol id="0507_suitcase_travel_baggage_luggage" symbol={<Symbol0507 />} />
      <LazySymbol id="0508_tag_flight_baggage_luggage" symbol={<Symbol0508 />} />
      <LazySymbol id="0509_globus_world_travel_regional" symbol={<Symbol0509 />} />
      <LazySymbol id="0510_passport_travel" symbol={<Symbol0510 />} />
      <LazySymbol id="0511_suitcase_tag_travel_baggage_luggage" symbol={<Symbol0511 />} />
      <LazySymbol id="0512_flight_airport_transport_travel" symbol={<Symbol0512 />} />
      <LazySymbol id="0513_car_travel_road_trip" symbol={<Symbol0513 />} />
      <LazySymbol id="0514_camping_caravan_car_motorhome_travel" symbol={<Symbol0514 />} />
      <LazySymbol id="0515_4x4_offroad_jeep_mountains_tour_safari" symbol={<Symbol0515 />} />
      <LazySymbol id="0516_paris_city_travel_honeymoon_love_romantic" symbol={<Symbol0516 />} />
      <LazySymbol id="0517_san_francisco_california_bridge_golden_gate" symbol={<Symbol0517 />} />
      <LazySymbol id="0518_rome_italy_colosseum" symbol={<Symbol0518 />} />
      <LazySymbol id="0519_rio_de_jeneiro_brasil_jesus" symbol={<Symbol0519 />} />
      <LazySymbol id="0520_pisa_italy_leaning_tower" symbol={<Symbol0520 />} />
      <LazySymbol id="0521_petronal_tower_malaysia" symbol={<Symbol0521 />} />
      <LazySymbol id="0522_dubai_hotel_burj_al_arab" symbol={<Symbol0522 />} />
      <LazySymbol id="0523_berlin_brandenburger_tor_germany" symbol={<Symbol0523 />} />
      <LazySymbol id="0524_syndey_opera_australia" symbol={<Symbol0524 />} />
      <LazySymbol id="0525_ancient_egypt_pyramid" symbol={<Symbol0525 />} />
      <LazySymbol id="0526_netherlands_wind_mill" symbol={<Symbol0526 />} />
      <LazySymbol id="0527_lighthouse_shore_coast_sea" symbol={<Symbol0527 />} />
      <LazySymbol id="0528_castle" symbol={<Symbol0528 />} />
      <LazySymbol id="0529_cementary" symbol={<Symbol0529 />} />
      <LazySymbol id="0530_favorite_place_map" symbol={<Symbol0530 />} />
      <LazySymbol id="0531_baggage_luggage_hotel" symbol={<Symbol0531 />} />
      <LazySymbol id="0532_park_tree" symbol={<Symbol0532 />} />
      <LazySymbol id="0533_baloon_hot_air" symbol={<Symbol0533 />} />
      <LazySymbol id="0534_vespa_scooter_motorbike" symbol={<Symbol0534 />} />
    </>
  );
});

Travel.displayName = 'Travel';

export default Travel;
